import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import event from '~helpers/mixpanel';
import window from 'global/window';
import { Hosts } from '~helpers/environments';
import get from 'lodash/get';
import {
  ExclamationCircleFilled,
  FileSearchOutlined,
  InfoCircleOutlined,
  CloseCircleFilled,
  FormOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { Row, Col, Table, Spin, Button, Typography, Divider } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';
import * as bookingActions from '~actions/bookings';
import { communicationStatus } from '~constants';
import * as longtailBookingsActions from '~actions/longtail-bookings';
import BookingProcessBar from '~components/booking-process-bar/';
import InstantProcessBar from '~components/booking-process-bar/instant-book/';
import formatPrice from '~helpers/currency';
import { setPartEmailAddress, setPartPhoneNumber } from '~helpers/order';
import { orderInstalmentPlanType } from '~constants/bookings';
import {
  orderStage,
  instantBookOrderStage,
  instantBookOrderSecondaryStage,
  bookingJourneyType,
  orderSecondaryStage,
  counterOfferStage,
} from 'common/constants/booking';
import { setItem } from '~helpers/storage';
import SvgFormat from 'common/helpers/svgFormat';
import RejectModal from '~pages/longtail-bookings/reject-modal';
import AcceptModal from '~pages/longtail-bookings/accept-modal';
import TransferModal from '~pages/longtail-bookings/detail/transfer-modal';
import RefundModal from '~pages/longtail-bookings/detail/refund-modal';
import RefundRejectModal from '~pages/longtail-bookings/detail/reject-modal/';
import ChargeModal from '~pages/longtail-bookings/detail/charge-modal';
import GuarantorInfoModal from '~pages/longtail-bookings/detail/guarantor-info-modal';
import RefundProcess from '~pages/longtail-bookings/detail/refund-process';
import MsgCenterBtn from '~pages/longtail-bookings/detail/msg-center-btn';
import StudentInfo from '~pages/longtail-bookings/detail/student-info';
import DocumentInfo from '~pages/longtail-bookings/detail/document-info';
import GuarantorInfo from '~pages/longtail-bookings/detail/guarantor-info';
import {
  BookingCountdown,
  IconHint,
  IconAccept,
  IconNotAccept,
  IconTimerNotice,
  IconPropertyOutline,
} from 'common/components/svgs';
import CounterOfferModal from '~pages/longtail-bookings/counter-offer-modal';
import CounterOfferEditModal from '~pages/longtail-bookings/counter-offer-edit-modal';
import ReferenceModal from '~pages/longtail-bookings/detail/reference-modal';
import ConfirmNoPaymentEle from '~pages/longtail-bookings/detail/confirm-no-payment';
import InstantBookProcessesRecord from './components/instant-book-processes-record';
import { decodeBase64 } from 'common/helpers/decodeBase64';
import { pageType } from '~constants/pages';

const mapStateToProps = state => ({
  order: state.bookings.getIn(['order']).toJS(),
  landlordUser: state.pmsReducer.dashboard.account.toJS().account,
});

const mapDispatchToProps = dispatch => ({
  getLongtailBookingDetail: params => {
    dispatch(bookingActions.getLongtailBookingDetail(params));
  },
  setLongtailBookingDetail: () => {
    dispatch(bookingActions.setLongtailBookingDetail({}));
  },
  confirmOrder: (id, onSuccess, onError) => {
    dispatch(longtailBookingsActions.confirmOrder(id, onSuccess, onError));
  },
  rejectOrder: (id, rejectedReason, onSuccess, onError) => {
    dispatch(longtailBookingsActions.rejectOrder(id, rejectedReason, onSuccess, onError));
  },
  confirmRefund: (id, onSuccess, onError) => {
    dispatch(longtailBookingsActions.confirmRefund(id, onSuccess, onError));
  },
});

const { Paragraph } = Typography;

@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
export default class LongtailBookingsDetail extends React.Component {
  constructor(props) {
    super(props);
    const order = props.order.payload;

    this.state = {
      showAllProcess: false,
      loadingData: true,
      transferRecord: null,
      refundRecord: null,
      chargeRecord: null,
      showRefundComfirmBtn: false,
      currentTab: 0,
      isInstantBook: order?.bookingJourney === bookingJourneyType.INSTANT_BOOK,
      showInstalmentPlanType: order?.instalmentPlanType !== orderInstalmentPlanType.FULL_PAYMENT,
      showGuarantorInfo:
        order?.secondaryStage === instantBookOrderSecondaryStage.GUARANTOR_PROVIDED,
      showGuarantorInfoModal: false,
      refundRejectVisible: false,
      showReferenceModal: false,
      firstLoad: true,
    };

    this.query = queryString.parse(window.location.search);
    this.typeFromLiveChat = this.query.type || null;

    this.headerNav = null;
    this.bookingProcess = null;
    this.studentInfo = null;
    this.guarantorInfo = null;
    this.productInfo = null;
    this.paymentInfo = null;
    this.processList = [];
    this.needHiddenStage = [
      orderStage.WAITING_FOR_CONFIRMATION,
      orderStage.WAITING_FOR_PAYMENT,
      orderStage.LOST,
      instantBookOrderStage.FILLING_PERSONAL_INFO,
      instantBookOrderStage.SIGNING_AGREEMENT,
      instantBookOrderStage.MAKING_PAYMENT,
    ];

    this.counterOfferModalRef = React.createRef();
    this.headerNavList = {
      'booking-process': 'processes',
      'student-info': 'student',
      'document-info': 'document',
      'guarantor-info': 'guarantor',
      'product-info': 'product',
      'payment-info': 'payment',
      'commission-info': 'commissions',
      'payables-info': 'receivables',
      'transfer-info': 'transfers',
      'refund-info': 'refunds',
    };

    this.productColumns = [
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.room_type'),
        key: 'roomType',
        render: (text, record) =>
          props.t(
            `landlord.long_tail.booking.unit_type_category.${
              record.roomType ? record.roomType.toLowerCase() : ''
            }`,
          ),
        width: '10%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.room'),
        dataIndex: 'room',
        key: 'room',
        width: '15%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.sales_price'),
        key: 'salesPrice',
        render: (text, record) => formatPrice(record.salesPrice, record.currency),
        width: '10%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.sales_type'),
        key: 'salesType',
        render: (text, record) =>
          props.t(
            `cms:cms.form.label.tenancy.${record.salesType ? record.salesType.toLowerCase() : ''}`,
          ),
        width: '10%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.tenancy'),
        key: 'tenancy',
        dataIndex: 'tenancy',
        width: '10%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.discount'),
        key: 'discount',
        render: (text, record) =>
          record?.discountValue
            ? record?.discountType === 'ABSOLUTE'
              ? record.discountValue
              : `${record.discountValue}%`
            : '_',

        width: '10%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.product_info.total_price'),
        key: 'totalPrice',
        render: (text, record) => formatPrice(record.totalPrice, record.currency),
        width: '15%',
      },
    ];

    this.paymentColumns = [
      {
        title: props.t('landlord.long_tail.booking_details.label.payment_info.charge'),
        key: 'charge',
        dataIndex: 'name',
        width: '20%',
        render: (text, record) =>
          record.paymentCategory === 'FIRST_RENTAL' && record.instalmentPlanType === 'FULL_PAYMENT'
            ? props.t('landlord.long_tail.payment_info.value.rental')
            : record.name,
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payment_info.pay_through_student_com',
        ),
        key: 'payThroughStcom',
        width: '20%',
        render: (text, record) => (
          <span className="longtail-booking-details__pay-throught-value">
            <SvgFormat
              type={record.payThroughStcom ? 'icon-yes' : 'icon-no'}
              className={classNames('longtail-booking-details__pay-throught-value-icon', {
                'longtail-booking-details__pay-throught-value-icon--no': !record.payThroughStcom,
              })}
            />
            {props.t(
              `landlord.long_tail.booking_details.value.pay_through_student_com.${
                record.payThroughStcom ? 'yes' : 'no'
              }`,
            )}
          </span>
        ),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.payment_info.pay_time'),
        key: 'payTime',
        width: '25%',
        render: record => (record.status === 'PAID' ? record.updatedAt : '-'),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.payment_info.amount'),
        key: 'amount',
        width: '15%',
        render: (text, record) => formatPrice(record.price, record.currency),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.payment_info.status'),
        key: 'status',
        width: '10%',
        render: (text, record) =>
          record.payThroughStcom
            ? props.t(
                `landlord.long_tail.booking_details.field.payment_status.${record.status.toLowerCase()}`,
              )
            : '-',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.payment_info.actions'),
        key: 'actions',
        width: '10%',
        render: (text, record) => (
          <div>
            <If condition={record.status === 'PAID'}>
              <a
                role="presentation"
                className="longtail-booking-details__table-btn longtail-booking-details__table-btn--view-detail"
                onClick={() => {
                  this.handleViewChargeModal(record);
                }}
              >
                {props.t('cms:cms.properties.edit.review_modal.button.view_detail')}
              </a>
            </If>
            <If condition={record.status !== 'PAID'}>-</If>
          </div>
        ),
      },
    ];

    this.refundColumns = [
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_number'),
        key: 'id',
        dataIndex: 'referenceId',
        width: '12%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_item'),
        key: 'refundType',
        dataIndex: 'refundType',
        width: '10%',
        render: text =>
          text
            ? props.t(
                `landlord.long_tail.booking_details.label.refund_info.refund_type.${text.toLowerCase()}`,
              )
            : '-',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_method'),
        key: 'refundMethod',
        dataIndex: 'refundMethod',
        width: '10%',
        render: (text, record) => (
          <div className="longtail-booking-details__table-btn--refund-container">
            <span>
              {text
                ? props.t(
                    `landlord.long_tail.booking_details.label.refund_info.refund_method.${text.toLowerCase()}`,
                  )
                : '-'}
            </span>
            <FileSearchOutlined
              className="longtail-booking-details__file-search-icon"
              onClick={() => {
                this.handleViewRefundModal(record, false);
              }}
            />
          </div>
        ),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_from'),
        key: 'refundFrom',
        dataIndex: 'refundFrom',
        width: '13%',
        render: text =>
          text
            ? props.t(
                `landlord.long_tail.booking_details.label.refund_info.refund_direction.${text.toLowerCase()}`,
              )
            : '-',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_to'),
        key: 'refundTo',
        dataIndex: 'refundTo',
        width: '10%',
        render: text =>
          text
            ? props.t(
                `landlord.long_tail.booking_details.label.refund_info.refund_direction.${text.toLowerCase()}`,
              )
            : '-',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_date'),
        key: 'refundedAt',
        dataIndex: 'refundedAt',
        width: '10%',
        render: text => (text ? moment(text).format('DD/MM/YYYY') : '-' || '-'),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_amount'),
        key: 'amount',
        dataIndex: 'amount',
        width: '10%',
        render: (text, record) => formatPrice(record.amount, record.currency),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.refund_status'),
        key: 'status',
        dataIndex: 'status',
        width: '14%',
        render: (text, record, index) => (
          <div className="longtail-booking-details__table-btn--refund-container">
            <span
              ref={node => {
                this.processList[index] = node;
              }}
            >
              {text
                ? props.t(
                    `landlord.long_tail.booking_details.label.refund_info.status.${text.toLowerCase()}`,
                  )
                : '-'}
            </span>
            <Tooltip
              getTooltipContainer={() => this.processList[index]}
              arrowContent={<div className="rc-tooltip-arrow-inner" />}
              placement="topRight"
              trigger="hover"
              overlay={<RefundProcess refund={record} t={props.t} />}
              align={{
                offset: ['15%', -8],
              }}
            >
              <FileSearchOutlined className="longtail-booking-details__file-search-icon" />
            </Tooltip>
          </div>
        ),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.refund_info.title.actions'),
        key: 'actions',
        render: (text, record) => (
          <div>
            <Choose>
              <When
                condition={
                  record.refundFrom === 'ACCOMMODATION_PARTNER' &&
                  record.refundTo === 'STCOM' &&
                  record.status === 'PENDING_REFUND'
                }
              >
                <a
                  role="presentation"
                  className="longtail-booking-details__table-btn longtail-booking-details__table-btn--refund"
                  onClick={() => {
                    this.handleViewRefundModal(record, true);
                  }}
                >
                  {props.t('landlord.long_tail.booking_details.label.refund_info.action.refund')}
                </a>

                <Divider type="vertical" />

                <If condition={record.refundType === 'DEPOSIT'}>
                  <a
                    role="presentation"
                    className="longtail-booking-details__table-btn longtail-booking-details__table-btn--reject"
                    onClick={() => {
                      this.handleViewRefundRejectModal(record, true);
                    }}
                  >
                    {props.t('landlord.long_tail.booking_details.label.refund_info.action.reject')}
                  </a>
                </If>
              </When>

              <Otherwise>-</Otherwise>
            </Choose>
          </div>
        ),
      },
    ];

    this.payablesColumns = [
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.payables_number',
        ),
        key: 'referenceId',
        dataIndex: 'referenceId',
        width: '11%',
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.payables_type',
        ),
        key: 'type',
        width: '10%',
        render: (text, record) =>
          props.t(
            `landlord.long_tail.booking_details.label.payables_info.type.${record.receivableType.toLowerCase()}`,
          ),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.payables_method',
        ),
        key: 'method',
        width: '10%',
        render: (text, record) =>
          props.t(
            `landlord.long_tail.booking_details.label.payables_info.method.${record.receivableMethod.toLowerCase()}`,
          ),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.payables_status',
        ),
        key: 'status',
        width: '8%',
        render: (text, record) =>
          props.t(
            `landlord.long_tail.booking_details.label.payables_info.status.${record.status.toLowerCase()}`,
          ),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.booking_number',
        ),
        key: 'bookingNumber',
        dataIndex: 'bookingNumber',
        width: '11%',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.payables_info.title.commission'),
        key: 'commission',
        width: '10%',
        render: (text, record) =>
          formatPrice(record.commission.totalPrice, record.commission.currency, 2),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.payables_price',
        ),
        key: 'price',
        width: '10%',
        render: (text, record) => formatPrice(record.amount, record.currency, 2),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.invoice_number',
        ),
        key: 'invoiceNumber',
        width: '10%',
        render: (text, record) => record.invoiceNumber || '-',
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.payables_info.title.last_invoice_date',
        ),
        key: 'invoicedAt',
        width: '10%',
        render: (text, record) =>
          record.invoicedAt ? moment(record.invoicedAt).format('DD/MM/YYYY') : '-',
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.payables_info.title.paid_date'),
        key: 'paidAt',
        width: '10%',
        render: (text, record) => (
          <div style={{ maxWidth: 400, minWidth: 160 }}>
            {record.paidAt ? moment(record.paidAt).format('DD/MM/YYYY') : '-'}
          </div>
        ),
      },
    ];

    this.transferColumns = [
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.transfer_info.title.transfer_number',
        ),
        key: 'id',
        dataIndex: 'referenceId',
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.transfer_info.title.transfer_item',
        ),
        key: 'item',
        dataIndex: 'transferType',
        render: text =>
          text
            ? props.t(
                `landlord.long_tail.booking_details.label.transfer_info.type.${text.toLowerCase()}`,
              )
            : '-',
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.transfer_info.title.settlement_amount',
        ),
        key: 'amount',
        render: (text, record) => formatPrice(record.amount, record.currency, 2),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.transfer_info.title.transfer_status',
        ),
        key: 'status',
        dataIndex: 'status',
        render: text =>
          text
            ? props.t(
                `landlord.long_tail.booking_details.label.transfer_info.status.${text.toLowerCase()}`,
              )
            : '-',
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.transfer_info.title.planning_transfer_date',
        ),
        key: 'planningTransferDatetime',
        dataIndex: 'planningTransferDatetime',
        render: text => (text ? moment(text).format('DD/MM/YYYY') : '-'),
      },
      {
        title: props.t(
          'landlord.long_tail.booking_details.label.transfer_info.title.actual_transfer_date',
        ),
        key: 'actualTransferDatetime',
        dataIndex: 'actualTransferDatetime',
        render: text => (text ? moment(text).format('DD/MM/YYYY HH:mm:ss') : '-'),
      },
      {
        title: props.t('landlord.long_tail.booking_details.label.transfer_info.title.action'),
        key: 'actions',
        render: (text, record) =>
          record.status === 'TRANSFERRED' ? (
            <a
              role="presentation"
              className="longtail-booking-details__table-btn longtail-booking-details__table-btn--view-detail"
              onClick={() => {
                this.handleViewTransferModal(record);
              }}
            >
              {props.t('cms:cms.properties.edit.review_modal.button.view_detail')}
            </a>
          ) : (
            '-'
          ),
      },
    ];

    this.commissionFields = {
      commissionNumber: 'commission_number',
      bookingNumber: 'booking_number',
      bookingPrice: 'booking_price',
      commissionTier: 'commission_tier',
      commssionCharged: 'commssion_charged',
      bonusCommssionTier: 'bonus_commssion_tier',
      bonusCommssionCharged: 'bonus_commssion_charged',
      totalCommssionCharged: 'total_commssion_charged',
      commssionChargeStatus: 'commssion_charge_status',
    };

    this.commissionColumns = Object.keys(this.commissionFields).map(field => {
      const value = this.commissionFields[field];
      return {
        title: props.t(`landlord.long_tail.booking_details.label.commission_info.${value}`),
        dataIndex: field,
        key: field,
      };
    });
  }

  handlePageViewedTracking = () => {
    const { payload } = this.props.order;

    if (payload?.property) {
      const { stage, bookingJourney, referenceId } = payload;
      const { name, id, slug } = payload?.property;
      const decodedId = decodeBase64(id)?.id;
      const from = this.query.from?.split('|') || [];
      const referrerPage = from[0] || null;
      const referrerPosition = from[1] || null;
      event('Viewed Booking Details Page', {
        'Entry Position': {
          'Referrer Page': referrerPage,
          'Referrer Position': referrerPosition,
        },
        'Property Name': name,
        'Property ID': decodedId,
        'Property Slug': slug,
        'Booking Stage': stage?.toLowerCase(),
        'Booking Journey': bookingJourney?.toLowerCase(),
        'Booking ID': referenceId,
        'Current Page Type': pageType.bookingDetailPage,
      });
    }
  };

  componentDidMount() {
    const params = this.props.match.params;
    this.props.getLongtailBookingDetail(params);
    this.handleDetailScroll();
    document.addEventListener('scroll', this.handleDetailScroll);
    this.removeTypeQueryParam();
  }

  componentDidUpdate(prevProps) {
    if (this.props.order?.payload?.id !== prevProps.order?.payload?.id) {
      const order = this.props.order?.payload;

      this.setState({
        isInstantBook: order?.bookingJourney === bookingJourneyType.INSTANT_BOOK,
        showInstalmentPlanType: order?.instalmentPlanType !== orderInstalmentPlanType.FULL_PAYMENT,
        showGuarantorInfo:
          order?.secondaryStage === instantBookOrderSecondaryStage.GUARANTOR_PROVIDED,
      });
      const isInstantBookRefund =
        order?.bookingJourney === bookingJourneyType.INSTANT_BOOK && order?.stage === 'REFUNDING';
      const translation = isInstantBookRefund
        ? this.props.t('landlord.long_tail.booking.booking_status.refunding_type')
        : this.props.t(`landlord.long_tail.booking.booking_status.${order?.stage?.toLowerCase()}`);

      window.hurricane = {
        ...window.hurricane,
        chatInfo: {
          ...window.chatInfo,
          propertyName: order?.property?.name,
          propertyId: order?.property?.id,
          propertySlug: order?.property?.slug,
          bookingStatus: translation,

          bookingJourney:
            order?.bookingJourney === bookingJourneyType.INSTANT_BOOK
              ? 'instant_book'
              : 'semi-automatic',
        },
      };
    }

    if (this.props.order?.payload?.property && this.state.firstLoad) {
      this.handlePageViewedTracking();
      this.setState({ firstLoad: false });
    }
  }

  componentWillUnmount() {
    this.props.setLongtailBookingDetail();
    document.removeEventListener('scroll', this.handleDetailScroll);
  }

  handleViewTransferModal = record => {
    this.setState({
      transferRecord: record,
    });
  };

  isShowHeaderNav = type => {
    const { payload } = this.props.order;
    const targetProperty =
      payload.counterOffers?.length > 0 ? payload.counterOffers[0]?.property : payload.property;

    if (this.state.isInstantBook) {
      // instant book logic
      if (type === 'guarantor') {
        return false;
      }

      switch (payload.stage) {
        case instantBookOrderStage.FILLING_PERSONAL_INFO:
          return ['processes', 'product'].indexOf(type) !== -1;
        case instantBookOrderStage.MAKING_PAYMENT:
        case instantBookOrderStage.SIGNING_AGREEMENT:
          return ['processes', 'student', 'product'].indexOf(type) !== -1;
        case instantBookOrderStage.BOOKING_CONFIRMED:
        case instantBookOrderStage.COMPLETED:
        case instantBookOrderStage.CHECKED_IN:
        case instantBookOrderStage.CANCELLED:
        case instantBookOrderStage.REFUNDING:
          return (
            ['processes', 'student', 'product', 'payment'].indexOf(type) !== -1 ||
            payload[type]?.length > 0
          );
        case instantBookOrderStage.LOST:
          if (payload.secondaryStage === instantBookOrderSecondaryStage.NO_INVENTORY_AVAILABLE) {
            return ['processes', 'product'].indexOf(type) !== -1;
          }
          if (
            [
              instantBookOrderSecondaryStage.NON_SIGN_IN_TIME,
              instantBookOrderSecondaryStage.NON_PAY_IN_TIME,
            ].includes(payload.secondaryStage)
          ) {
            return ['processes', 'student', 'product'].indexOf(type) !== -1;
          }
          break;
        default:
          return false;
      }
    } else {
      // semi-automatic logic
      if (['processes', 'student', 'product', 'payment'].indexOf(type) !== -1) {
        return true;
      }

      if (payload && payload[type] && Object.keys(payload[type]).length > 0) {
        return true;
      }

      if (type === 'document') {
        return this.showDocumentInfoModule(targetProperty);
      }
    }

    return false;
  };

  handleViewRefundModal = (record, showRefundComfirmBtn = false) => {
    this.setState({
      refundRecord: record,
      showRefundComfirmBtn,
    });
  };

  handleViewRefundRejectModal = (record, refundRejectVisible = false) => {
    this.setState({
      refundRejectRecord: record,
      refundRejectVisible,
    });
  };

  handleViewChargeModal = record => {
    this.setState({
      chargeRecord: record,
    });
  };

  handleViewGuarantorInfoModal = () => {
    this.setState({
      showGuarantorInfoModal: !this.state.showGuarantorInfoModal,
    });
  };

  removeTypeQueryParam = () => {
    if (this.typeFromLiveChat) {
      delete this.query.type;
      const deleteTypeQuery = queryString.stringify(this.query)
        ? `?${queryString.stringify(this.query)}`
        : '';

      window.history.replaceState(null, null, `${window.location.pathname}${deleteTypeQuery}`);
    }
  };

  getLongtailBookingDetail = () => {
    const params = this.props.match.params;
    this.props.getLongtailBookingDetail(params);
  };

  confirmOrder = id => {
    this.typeFromLiveChat = null;
    const bookingId = id || this?.props?.order?.payload?.id;
    this.props.confirmOrder(
      bookingId,
      () => {
        const { payload } = this.props.order;
        if (payload?.property) {
          const { bookingJourney, referenceId } = payload;
          const { name, id, slug } = payload?.property;
          const decodedId = decodeBase64(id)?.id;
          event('Successfully Actioned on Booking', {
            'Action Type': 'Accept',
            'Booking ID': referenceId,
            'Property Name': name,
            'Property ID': decodedId,
            'Property Slug': slug,
            'Booking Journey': bookingJourney?.toLowerCase(),
            // after confirm, stage will be changed to WAITING_FOR_PAYMENT
            'Booking Stage': orderStage.WAITING_FOR_PAYMENT.toLowerCase(),
            'Current Page Type': pageType.bookingDetailPage,
          });
        }
        this.getLongtailBookingDetail();
      },
      this.getLongtailBookingDetail,
    );
  };

  rejectOrder = (id, rejectedReason) => {
    this.typeFromLiveChat = null;

    if (id) {
      this.props.rejectOrder(
        id,
        rejectedReason,
        () => {
          const { payload } = this.props.order;
          if (payload?.property) {
            const { bookingJourney, referenceId } = payload;
            const { name, id, slug } = payload?.property;
            const decodedId = decodeBase64(id)?.id;
            event('Successfully Actioned on Booking', {
              'Action Type': 'Reject',
              'Booking ID': referenceId,
              'Property Name': name,
              'Property ID': decodedId,
              'Property Slug': slug,
              'Booking Journey': bookingJourney?.toLowerCase(),
              // after reject, stage will be changed to LOST
              'Booking Stage': orderStage.LOST.toLowerCase(),
              'Current Page Type': pageType.bookingDetailPage,
            });
          }
          this.getLongtailBookingDetail();
        },
        this.getLongtailBookingDetail,
      );
    }
  };

  counterOfferRejectEvent = ({ variables }) => {
    const { id, rejectedReason } = variables?.input;
    if (id) {
      this.props.rejectOrder(
        id,
        rejectedReason,
        () => {
          this.getLongtailBookingDetail();
        },
        this.getLongtailBookingDetail,
      );
    }
  };
  handleDetailScroll = () => {
    if (
      this.headerNav &&
      this.studentInfo &&
      this.paymentInfo &&
      this.productInfo &&
      this.transferInfo &&
      this.commissionInfo &&
      this.payablesInfo &&
      this.bookingProcess
    ) {
      const blockList = [
        { 'booking-process': this.bookingProcess.getBoundingClientRect().top },
        { 'student-info': this.studentInfo.getBoundingClientRect().top },
        { 'product-info': this.productInfo.getBoundingClientRect().top },
        { 'payment-info': this.paymentInfo.getBoundingClientRect().top },
        { 'commission-info': this.commissionInfo.getBoundingClientRect().top },
        { 'payables-info': this.payablesInfo.getBoundingClientRect().top },
        { 'transfer-info': this.transferInfo.getBoundingClientRect().top },
      ];
      if (this.guarantorInfo) {
        blockList.push({ 'guarantor-info': this.guarantorInfo.getBoundingClientRect().top });
      }
      if (this.refundInfo) {
        blockList.push({ 'refund-info': this.refundInfo.getBoundingClientRect().top });
      }

      const bookingProcessTop = blockList[0]['booking-process'];

      if (
        bookingProcessTop <= 72 &&
        !this.headerNav.classList.contains('longtail-booking-details__header-nav--sticky')
      ) {
        this.headerNav.classList.add('longtail-booking-details__header-nav--sticky');
      } else if (
        bookingProcessTop > 72 &&
        this.headerNav.classList.contains('longtail-booking-details__header-nav--sticky')
      ) {
        this.headerNav.classList.remove('longtail-booking-details__header-nav--sticky');
      }

      // const underNavTop = blockList.find(block => {
      //   const blockKey = Object.keys(block)[0];
      //   return block[blockKey] > 0;
      // });
    }
  };
  eventNameMap = eventName => {
    const nameMap = {
      'student-info': 'Student info',
      'booking-process': 'Booking Process',
      'product-info': 'Product info',
      'payment-info': 'Payment info',
    };
    return nameMap[eventName];
  };
  handleNavClick = (target, idx) => {
    this.handleClickTabTrack(this.eventNameMap(target));
    const targetElement = document.querySelector(`#${target}`);

    this.setState({
      currentTab: idx,
    });
    if (targetElement) {
      window.scrollTo(0, targetElement.offsetTop - 73);
    }
  };

  hiddenPhoneByStatus = (phone, status) =>
    this.needHiddenStage.indexOf(status) !== -1 ? setPartPhoneNumber(phone) : phone;

  hiddenEmailByStatus = (email, status) =>
    this.needHiddenStage.indexOf(status) !== -1 ? setPartEmailAddress(email) : email;

  calcTenancyLength = (moveIn, moveOut) => {
    const diffDate = moment(moveOut).diff(moment(moveIn), 'days');

    let tenancyDesc = '';
    if (diffDate > 0) {
      if (diffDate < 7) {
        tenancyDesc = this.props.t(
          'landlord.longtail_enquiry.property_card.only_days.tenancy_desc',
          {
            days: diffDate % 7,
          },
        );
      } else if (diffDate % 7) {
        tenancyDesc = this.props.t(
          'landlord.longtail_enquiry.property_card.have_days.tenancy_desc',
          {
            weeks: Math.floor(diffDate / 7),
            days: diffDate % 7,
          },
        );
      } else {
        tenancyDesc = this.props.t(
          'landlord.longtail_enquiry.property_card.only_weeks.tenancy_desc',
          {
            weeks: diffDate / 7,
          },
        );
      }
    }
    return tenancyDesc;
  };

  getProductData = () => {
    const order = this.props.order?.payload;

    const payload = order?.counterOffers?.[0] ? order?.counterOffers?.[0]?.originOrder : order;
    const tenancyLength = this.calcTenancyLength(payload.moveInDate, payload.moveOutDate);

    return [
      {
        listingId: payload.listingId,
        property: order.propertyName,
        roomType: payload.unitTypeCategory,
        room: payload.unitTypeName,
        salesPrice: payload.listingSalesPrice,
        salesType: payload.billingCycle,
        tenancy: tenancyLength,
        totalPrice: payload.totalPrice,
        currency: payload.currency,
      },
    ];
  };

  gotoProperty = type => {
    const payload = this.props.order.payload;
    const { counterOffers } = payload;
    const counterOffersInfo = counterOffers?.[0];
    const target =
      type === 'order'
        ? counterOffersInfo
          ? counterOffersInfo?.originOrder
          : payload
        : counterOffersInfo;

    const property = target.property;

    let path = null;

    const countrySlug = property?.city?.country?.slug ?? payload?.city?.country?.slug;
    const citySlug = property?.city?.slug ?? payload?.city?.slug;

    if (property?.status === 'PUBLISHED' && property?.slug) {
      path = `${countrySlug}/${citySlug}/p/${property?.slug}`;
    } else {
      path = `${countrySlug}/${citySlug}/p/404`;
    }

    return `${Hosts.propertyUrl}${path}`;
  };

  getProductInfoHeader = (type = 'order') => {
    const payload = this.props.order.payload;
    const { counterOffers } = payload;
    const counterOffersInfo = counterOffers?.[0];

    const target =
      type === 'order'
        ? counterOffersInfo
          ? counterOffersInfo?.originOrder
          : payload
        : counterOffersInfo;

    const propertyName = target.property?.name || target?.propertyName;
    const propertyAddress =
      (target.property?.address ?? '') + (target.property?.addressLine2 ?? '');

    return (
      <div className="longtail-booking-details__block-table--header">
        <IconPropertyOutline className="longtail-booking-details__block-table--header__icon" />

        <h4 className="longtail-booking-details__block-table--header__name">
          <a target="_blank" href={this.gotoProperty(type)} rel="noopener noreferrer">
            {propertyName}
          </a>
        </h4>

        <h6 className="longtail-booking-details__block-table--header__address">
          {propertyAddress}
        </h6>
      </div>
    );
  };

  getCounterOffer = () => {
    const payload = this.props.order.payload;
    const { counterOffers } = payload;
    const counterOffersInfo = counterOffers?.[0];
    const tenancyLength = this.calcTenancyLength(
      counterOffersInfo?.moveInDate,
      counterOffersInfo?.moveOutDate,
    );
    return [
      {
        listingId: counterOffersInfo?.listingId,
        property: payload?.propertyName,
        roomType: counterOffersInfo?.unitTypeCategory,
        room: counterOffersInfo?.unitTypeName,
        salesPrice: counterOffersInfo?.listingSalesPrice,
        salesType: counterOffersInfo?.billingCycle,
        tenancy: tenancyLength,
        totalPrice: counterOffersInfo?.totalPrice,
        currency: counterOffersInfo?.currency,
        discountValue: counterOffersInfo?.discountValue,
        discountType: counterOffersInfo?.discountType,
      },
    ];
  };
  getCommissionData = () => {
    const { t } = this.props;
    const payload = this.props.order.payload;
    const commissionsData = [];

    if (payload && payload.commissions) {
      payload.commissions.map(commission => {
        commissionsData.push({
          commissionNumber: commission.referenceId,
          bookingNumber: payload.referenceId,
          bookingPrice:
            payload.totalPrice !== null
              ? formatPrice(payload.totalRental, commission.currency)
              : '-',
          commissionTier: this.formatCommissionTier(
            commission.commissionTierValue,
            commission.commissionTierType,
            commission.currency,
          ),
          commssionCharged:
            commission.basePrice !== null
              ? formatPrice(commission.basePrice, commission.currency)
              : '-',
          bonusCommssionTier: this.formatCommissionTier(
            commission.bonusCommissionTierValue,
            commission.bonusCommissionTierType,
            commission.currency,
          ),
          bonusCommssionCharged:
            commission.bonusPrice !== null
              ? formatPrice(commission.bonusPrice, commission.currency)
              : '-',
          totalCommssionCharged:
            commission.totalPrice !== null
              ? formatPrice(commission.totalPrice, commission.currency)
              : '-',
          commssionChargeStatus: t(
            `landlord.long_tail.booking_details.label.commission_info.stage.${commission.status.toLowerCase()}`,
          ),
        });

        return true;
      });
    }

    return commissionsData;
  };

  formatCommissionTier = (value, type, currency) => {
    if (Number(value) && type === 'PERCENTAGE') {
      return `${value}%`;
    }

    if (Number(value) && type === 'UNIT_PRICE') {
      return `${value}${this.props.t('cms:cms.property.commission.list.unit_price_commission')}`;
    }

    if (Number(value)) {
      return formatPrice(value, currency);
    }

    return '-';
  };

  getPaymentData = payThroughStcom => {
    const payload = this.props.order.payload;
    if (payload && payload.payments) {
      return payload.payments
        .filter(payment => payment.payThroughStcom === payThroughStcom)
        .map(payment => ({
          ...payment,
          instalmentPlanType: payload.instalmentPlanType,
          charge: payment.orderChargeId
            ? payload.charges.find(charge => charge.id === payment.orderChargeId)
            : null,
          paidAt: payload.paidAt,
        }));
    }
    return [];
  };

  isProcessFailed = process => {
    const { currentStage } = process;

    return !![
      orderStage.LOST,
      orderStage.CANCELLED,
      orderStage.AFTER_SALES_INTERVENTION,
      orderStage.REFUNDING,
    ].includes(currentStage);
  };

  handleShowAll = () => {
    this.setState({
      showAllProcess: !this.state.showAllProcess,
    });
  };

  processDesc = (process, isRerserveRoom) => {
    const { currentStage, currentSecondaryStage, noPayment } = process;

    const { payload } = this.props.order;

    const isNoPayment = !payload?.paymentOnline;

    const reserveNoPayment = isRerserveRoom && isNoPayment;

    const mpNoPayment = !isRerserveRoom && isNoPayment;

    const isCanceledByStudent =
      currentStage === orderStage.CANCELLED &&
      currentSecondaryStage === orderSecondaryStage.CANCEL_BY_STUDENT;

    if (reserveNoPayment && currentStage === instantBookOrderStage.SELECTING_PAYMENT_PLAN) {
      return this.props.t('landlord.longtail_booking.process.stage.selecting_payment_plan', {
        modifier_name: process.modifierName,
      });
    }

    if (reserveNoPayment && isCanceledByStudent) {
      return this.props.t(
        'landlord.longtail_booking.process.stage.reserve_room.cancel_by_student',
        {
          modifier_name: process.modifierName,
        },
      );
    }

    if (currentStage === 'pending_payment') {
      return this.props.t('landlord.longtail_booking.process.record.no_payment.pending_payment', {
        modifier_name: `${payload.student.firstName} ${payload.student.lastName}`,
      });
    }

    if (currentStage === 'reselecting_payment_plan') {
      return this.props.t('landlord.longtail_booking.process.title.reselecting_payment_plan');
    }

    if (mpNoPayment && currentStage === orderStage.WAITING_FOR_CHECK_IN) {
      return !payload?.landlordConfirmedPayment
        ? this.props.t('landlord.longtail_booking.process.record.no_payment.pending_payment', {
            modifier_name: `${payload.student.firstName} ${payload.student.lastName}`,
          })
        : this.props.t('landlord.longtail_booking.process.record.no_payment.payment_received', {
            landlord_name: payload.landlord?.name,
          });
    }

    if (mpNoPayment && isCanceledByStudent) {
      if (noPayment) {
        return this.props.t(
          'landlord.longtail_booking.process.record.no_payment.cancel_by_student',
          {
            modifier_name: process.modifierName,
          },
        );
      }
      return this.props.t(
        'landlord.longtail_booking.process.record.no_payment.cancel_by_student_canceled',
      );
    }

    return this.props.t(
      `landlord.${
        this.state.isInstantBook &&
        [instantBookOrderStage.CANCELLED, instantBookOrderStage.REFUNDING].includes(
          process.currentStage,
        )
          ? 'instant_booking'
          : 'longtail_booking'
      }.process.record.${process.currentStage?.toLowerCase()}${
        process?.currentSecondaryStage ? `.${process.currentSecondaryStage?.toLowerCase()}` : ''
      }`,
      { modifier_name: process.modifierName },
    );
  };
  handleTotalHint = () => {
    const payload = this.props.order.payload;
    const { t } = this.props;
    let feeArr = [],
      depositArr = [];
    if (payload && payload.payments) {
      feeArr = payload.payments.filter(payment => payment.paymentCategory === 'FEE');
      depositArr = payload.payments.filter(payment => payment.paymentCategory === 'DEPOSIT');
    }

    return (
      <div className="longtail-booking-details__total--box">
        <InfoCircleOutlined className="longtail-booking-details__total--icon" />
        <div className="longtail-booking-details__total--hover">
          <div className="longtail-booking-details__total--hover-triangle" />
          <div className="longtail-booking-details__total--contents">
            <div className="longtail-booking-details__total--top">
              <span className="longtail-booking-details__total-line" />
              <span>{t('landlord.long_tail.booking.action.total.hint.title')}</span>
            </div>

            <div className="longtail-booking-details__total--total-info">
              <div>{t('landlord.long_tail.booking.action.total.hint.rent')} </div>
              <div>{formatPrice(payload?.totalRental, payload?.currency)}</div>
            </div>

            <If condition={depositArr.length > 0}>
              <For each="deposit" of={depositArr} index="index">
                <div className="longtail-booking-details__total--total-info">
                  <div> {deposit?.name} </div>
                  <div>{formatPrice(deposit?.price, deposit?.currency)}</div>
                </div>
              </For>
            </If>

            <If condition={feeArr.length > 0}>
              <For each="fee" of={feeArr} index="index">
                <div className="longtail-booking-details__total--total-info">
                  <div>{fee?.name}</div>
                  <div>{formatPrice(fee?.price, fee?.currency)}</div>
                </div>
              </For>
            </If>
          </div>
        </div>
      </div>
    );
  };

  renderProcessRecord = (
    processes,
    showAllProcess,
    hasRejectedRefund,
    hasStripeRefundedRefund,
    hasNonStripeRefundedRefund,
    isHercules,
    isRerserveRoom,
  ) => {
    const { payload } = this.props.order;
    const isNoPayment = !payload?.paymentOnline;
    let newProcess = [...processes];
    let showMoreOrLess = showAllProcess;
    if (hasRejectedRefund) {
      const rejectInfo = Object.assign({}, processes[processes?.length - 1]);
      rejectInfo.currentSecondaryStage = 'Rejected';
      newProcess?.splice(processes?.length - 1, 0, rejectInfo);
    }
    newProcess.sort((a, b) => (moment(a.updatedAt).isBefore(b.updatedAt) ? 1 : -1));
    const cancelledByStudent = newProcess.find(
      processInfo =>
        processInfo.currentSecondaryStage === orderSecondaryStage.CANCEL_BY_STUDENT &&
        processInfo.currentStage === orderStage.CANCELLED,
    );
    const cancelledBystudentIdx = newProcess.findIndex(
      processInfo =>
        processInfo.currentSecondaryStage === orderSecondaryStage.CANCEL_BY_STUDENT &&
        processInfo.currentStage === orderStage.CANCELLED,
    );
    newProcess.forEach(item => {
      if (
        item?.currentStage !== orderStage.WAITING_FOR_PAYMENT &&
        item?.currentSecondaryStage === orderSecondaryStage.COUNTER_OFFER_ACCEPTED_BY_STUDENT
      ) {
        item['currentSecondaryStage'] = '';
      }
    });
    // 针对no payemnt && cancelled by student
    if (isHercules && isNoPayment && cancelledByStudent) {
      newProcess.splice(cancelledBystudentIdx + 1, 0, {
        ...cancelledByStudent,
        noPayment: true,
      });
    }

    if (isNoPayment && isHercules) {
      newProcess.map((item, index) => {
        if (
          item.currentStage === orderStage.WAITING_FOR_PAYMENT &&
          item.currentSecondaryStage === orderSecondaryStage.COUNTER_OFFER_ACCEPTED_BY_STUDENT
        ) {
          newProcess[index] = { ...item, currentStage: 'reselecting_payment_plan' };
        }
      });

      if (payload.landlordConfirmedPayment) {
        const targetIndex = newProcess.findIndex(
          item => item.currentStage === orderStage.WAITING_FOR_CHECK_IN,
        );
        newProcess.splice(targetIndex + 1, 0, {
          ...newProcess[targetIndex],
          currentStage: 'pending_payment',
        });
      }
    }

    showMoreOrLess = newProcess.length > 2;

    if (!showAllProcess) {
      newProcess = newProcess.slice(0, 2);
    }

    return (
      <>
        <For each="process" of={newProcess} index="key">
          <div className="longtail-booking-details__status" key={key}>
            <div
              className={classNames('longtail-booking-details__process-detail-point', {
                'longtail-booking-details__process-detail-point--failed':
                  this.isProcessFailed(process),
              })}
            />
            <span className="longtail-booking-details__process-time">
              {moment(process.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
            </span>
            <Choose>
              {/* hercules reject refund  */}
              <When
                condition={
                  hasRejectedRefund && isHercules && process?.currentSecondaryStage === 'Rejected'
                }
              >
                <span className="longtail-booking-details__status-text">
                  {this.props.t('landlord.longtail_booking_process.hercules_refund_reject_desc')}
                </span>
              </When>

              <When
                condition={
                  hasRejectedRefund &&
                  isRerserveRoom &&
                  process?.currentSecondaryStage === 'Rejected'
                }
              >
                <span className="longtail-booking-details__status-text">
                  {this.props.t(
                    'landlord.longtail_booking_process.instant_book_refund_reject_desc',
                  )}
                </span>
              </When>

              {/* ReserveRoom  stripe refund*/}
              <When
                condition={
                  isRerserveRoom &&
                  hasStripeRefundedRefund &&
                  process?.currentStage === 'REFUNDING' &&
                  process?.currentSecondaryStage === 'PARTIAL_NON_REFUND'
                }
              >
                <span className="longtail-booking-details__status-text">
                  {this.props.t('landlord.longtail_booking_process.refund_refuned_desc')}
                </span>
              </When>

              {/* ReserveRoom  非stripe refund*/}
              <When
                condition={
                  isRerserveRoom &&
                  hasNonStripeRefundedRefund &&
                  process?.currentStage === 'REFUNDING' &&
                  process?.currentSecondaryStage === 'PARTIAL_NON_REFUND'
                }
              >
                <span className="longtail-booking-details__status-text">
                  {this.props.t(
                    'landlord.instant_booking.process.record.refunding.partial_non_refund',
                  )}
                </span>
              </When>
              <Otherwise>
                <span className="longtail-booking-details__status-text">
                  {this.processDesc(process, isRerserveRoom)}
                </span>
              </Otherwise>
            </Choose>
          </div>
          {/* <If
          condition={
            !isRerserveRoom &&
            isNoPayment &&
            process.currentStage === orderStage.WAITING_FOR_CHECK_IN &&
            !payload?.landlordConfirmedPayment
          }
        >
          <div className="longtail-booking-details__status" key={key}>
            <div
              className={classNames('longtail-booking-details__process-detail-point', {
                'longtail-booking-details__process-detail-point--failed':
                  this.isProcessFailed(process),
              })}
            />
            <span className="longtail-booking-details__process-time">
              {moment(process.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
            </span>
            <span className="longtail-booking-details__status-text">
              {this.props.t('landlord.longtail_booking.process.record.booking_confirmed')}
            </span>
          </div>
        </If> */}
        </For>
        <If condition={showMoreOrLess}>
          <button className="longtail-booking-details__view-more" onClick={this.handleShowAll}>
            {!this.state.showAllProcess
              ? this.props.t('landlord.longtail_booking.btn.view_more')
              : this.props.t('landlord.longtail_booking.btn.view_less')}
          </button>
        </If>
      </>
    );
  };

  getPayablesData = receivables => {
    if (receivables) {
      const { payload } = this.props.order;
      return receivables.map(receivable => ({
        ...receivable,
        bookingNumber: payload.referenceId,
      }));
    }
    return [];
  };

  getRefundData = refunds => {
    if (refunds) {
      const { payload } = this.props.order;
      return refunds.map(refund => ({
        ...refund,
        passportFirstName: payload.passportFirstName,
        passportLastName: payload.passportLastName,
      }));
    }
    return [];
  };

  renderTooltipContainer = text => (
    <div className="longtail-booking-details__tooltip-container">
      <span className="longtail-booking-details__tooltip-container__text">{text}</span>
    </div>
  );

  handleClickTabTrack = position => {
    const { payload } = this.props.order;
    if (payload?.property) {
      const { stage, bookingJourney, referenceId } = payload;
      const { name, id, slug } = payload?.property;
      const decodedId = decodeBase64(id)?.id;
      event('Clicked Booking Details Info Tab', {
        'Click Position': position,
        'Property Name': name,
        'Property ID': decodedId,
        'Property Slug': slug,
        'Booking Stage': stage?.toLowerCase(),
        'Booking Journey': bookingJourney?.toLowerCase(),
        'Booking ID': referenceId,
        'Current Page Type': pageType.bookingDetailPage,
      });
    }
  };

  handleClickActionBtnTrack = position => {
    const { payload } = this.props.order;
    if (payload?.property) {
      const { stage, bookingJourney, referenceId } = payload;
      const { name, id, slug } = payload?.property;
      const decodedId = decodeBase64(id)?.id;
      event('Clicked Action Btn in Booking Details Page', {
        'Click Position': position,
        'Property Name': name,
        'Property ID': decodedId,
        'Property Slug': slug,
        'Booking Stage': stage?.toLowerCase(),
        'Booking Journey': bookingJourney?.toLowerCase(),
        'Booking ID': referenceId,
        'Current Page Type': pageType.bookingDetailPage,
      });
    }
  };

  checkCounterOffer = () => {
    this.handleClickTabTrack('Check Offer Details');
    window.scrollTo(0, this.productInfo.offsetTop + 30);
  };
  openOrderCounterOfferModal = () => {
    this.handleClickActionBtnTrack('Counter');
    setItem('counterOfferFrom', 'Booking Details Page');
    this.counterOfferModalRef.current?.handleOpenModal(this.props?.order?.payload);
  };

  refetchBookingDetail = () => {
    this.typeFromLiveChat = null;
    this.getLongtailBookingDetail();
  };

  openReferenceModal = () => {
    this.setState({
      showReferenceModal: true,
    });
  };

  closeReferenceModal = () => {
    this.setState({
      showReferenceModal: false,
    });
  };

  showDocumentInfoModule = targetProperty => {
    const { order } = this.props;
    const { payload } = order;

    if ([orderStage.LOST, orderStage.CANCELLED, orderStage.REFUNDING].includes(payload?.stage)) {
      return false;
    }

    if (targetProperty?.documentations?.every(item => !item.check)) {
      return false;
    }

    return true;
  };

  render() {
    const { t, landlordUser, order } = this.props;
    const { payload, communication } = order;
    const {
      processes,
      guarantor,
      student,
      studentData,
      refunds,
      receivables,
      transfers,
      counterOffers,
      bookingJourney,
      stage,
      secondaryStage,
      id,
      externalId,
      paymentOnline,
      instalmentPlanType,
    } = payload;
    const isHercules = bookingJourney === 'SEMI_AUTOMATIC';
    const isRerserveRoom = bookingJourney === 'INSTANT_BOOK';
    const isNoPayment = !paymentOnline;
    const targetProperty =
      payload.counterOffers?.length > 0 ? payload.counterOffers[0]?.property : payload.property;

    const isShowDocumentInfo = this.showDocumentInfoModule(targetProperty);

    // reject 在process添加一组信息

    const hasRejectedRefund =
      stage === 'CANCELLED' && secondaryStage === 'CANCEL_BY_STUDENT_PARTIAL_REFUNDED';
    // stripe的退款
    const hasStripeRefundedRefund = refunds?.some(refund => refund?.refundMethod === 'STRIPE');
    // 非stripe的退款
    const hasNonStripeRefundedRefund = refunds?.some(refund => refund?.refundMethod !== 'STRIPE');

    const isShowMsgCenterIcon = this.state.isInstantBook
      ? [
          instantBookOrderStage.BOOKING_CONFIRMED,
          instantBookOrderStage.COMPLETED,
          instantBookOrderStage.CHECKED_IN,
          instantBookOrderStage.CANCELLED,
          instantBookOrderStage.REFUNDING,
        ].includes(payload.stage)
      : true;

    const isShownBookingProcessDetail = this.state.isInstantBook
      ? processes?.some(process =>
          [instantBookOrderStage.CANCELLED, instantBookOrderStage.REFUNDING].includes(
            process.currentStage,
          ),
        )
      : true;

    const ProcessBar = this.state.isInstantBook ? InstantProcessBar : BookingProcessBar;

    const showStudentBasicInfo = payload?.stage !== instantBookOrderStage.FILLING_PERSONAL_INFO;

    if (communication.status === communicationStatus.FETCHING) {
      return (
        <div className="longtail-booking-details__loading">
          <Spin size="large" />
        </div>
      );
    }
    const isShowCounterOffer = payload.secondaryStage === orderSecondaryStage.PENDING_COUNTER_OFFER;

    // counter offered，没在有效期
    const isOverTime =
      payload?.secondaryStage === orderSecondaryStage.COUNTER_OFFER_NON_CONFIRM_IN_TIME;
    const counterOffersInfo = counterOffers?.[0];

    const isNotComplete =
      [orderStage.LOST, orderStage.CANCELLED, orderStage.REFUNDING].includes(payload?.stage) &&
      counterOffersInfo?.stage &&
      ![
        orderSecondaryStage.WAITING_FOR_CONFIRMATION,
        orderSecondaryStage.ACCEPTED,
        orderSecondaryStage.CANCELLED,
      ].includes(counterOffersInfo?.stage);

    const isAcceptByStudent =
      ![orderStage.LOST, orderStage.CANCELLED, orderStage.REFUNDING].includes(payload?.stage) &&
      payload?.counterOffers?.[0]?.stage === counterOfferStage.ACCEPTED;

    const isAcceptOriginalByLandlord =
      payload?.counterOffers?.[0]?.stage === counterOfferStage.CANCELLED &&
      ![orderStage.LOST, orderStage.CANCELLED, orderStage.REFUNDING].includes(payload?.stage);

    const isRejectByStudent =
      payload?.stage === orderStage.LOST &&
      payload?.secondaryStage === orderSecondaryStage.COUNTER_OFFER_REJECTED_BY_STUDENT;

    const isNoPaymentReselectPaymentPlan =
      isHercules &&
      stage === orderStage.WAITING_FOR_PAYMENT &&
      secondaryStage === orderSecondaryStage.COUNTER_OFFER_ACCEPTED_BY_STUDENT &&
      !paymentOnline &&
      !instalmentPlanType;

    const handleBookingStatus = () => {
      if (isHercules) {
        if (isNoPaymentReselectPaymentPlan) {
          return t('landlord.long_tail.booking.booking_status.no_payment.need_select_payment');
        } else if (
          (!order.payload.paymentOnline &&
            order.payload.instalmentPlanType &&
            order.payload.stage === orderStage.WAITING_FOR_CHECK_IN &&
            !order?.payload.landlordConfirmedPayment) ||
          (this.state.isInstantBook &&
            [instantBookOrderStage.COMPLETED, instantBookOrderStage.BOOKING_CONFIRMED].includes(
              order.payload.stage,
            ) &&
            !order?.payload.landlordConfirmedPayment)
        ) {
          return t('landlord.long_tail.booking.booking_status.waiting_for_payment');
        }
      }

      if (
        isRerserveRoom &&
        !order.payload.paymentOnline &&
        [instantBookOrderStage.BOOKING_CONFIRMED, instantBookOrderStage.COMPLETED].includes(
          order?.payload?.stage,
        ) &&
        !order?.payload.landlordConfirmedPayment
      ) {
        return t('landlord.long_tail.booking.booking_status.waiting_for_payment');
      }

      return t(
        `landlord.long_tail.booking.booking_status.${
          order.payload.stage ? order.payload.stage.toLowerCase() : ''
        }`,
      );
    };

    return (
      <div className="longtail-booking-details">
        <div className="longtail-booking-details__header-container">
          <div className="longtail-booking-details__crumb">
            <Link to="/booking/list">{t('landlord.header.menu_link.booking')}</Link>
            <span className="longtail-booking-details__slash">/</span>
            <Link to="/booking/list">{t('landlord.header.menu_link.booking.list')}</Link>
            <span className="longtail-booking-details__slash">/</span>
            <span className="longtail-booking-details__current">
              {t('landlord.header.menu_link.booking.details')}
            </span>
          </div>

          <Row style={{ paddingBottom: '24px' }}>
            <Col span={16}>
              <h3 className="longtail-booking-details__booking-number">
                {`${t('landlord.long_tail.booking_details.title.booking_number')} - ${
                  payload.referenceId
                }`}
                <If condition={isShowCounterOffer}>
                  <span className="longtail-booking-details__counter-offer-countdownbox">
                    <BookingCountdown className="longtail-booking-details__counter-offer-countdownIcon" />
                    <span className="longtail-booking-details__counter-offer-countdown">
                      {t('landlord.booking.counter_offer.detail.counter_offer')}
                    </span>
                  </span>
                </If>
              </h3>
              <div className="longtail-booking-details__student-info">
                <Row className="longtail-booking-details__info-row" gutter={50}>
                  <Col span={12} className="longtail-booking-details__info-col">
                    <Tooltip
                      overlayClassName="longtail-booking-details__info-tooltip"
                      placement="topLeft"
                      trigger="hover"
                      overlay={this.renderTooltipContainer(
                        t('landlord.long_tail.booking_details.label.student_name', {
                          value: `${
                            student?.passportFirstName && showStudentBasicInfo
                              ? student?.passportFirstName + ' ' + student?.passportLastName
                              : '-'
                          }`,
                        }),
                      )}
                    >
                      <Paragraph ellipsis className="longtail-booking-details__info">
                        {t('landlord.long_tail.booking_details.label.student_name', {
                          value: `${
                            student?.passportFirstName && showStudentBasicInfo
                              ? student?.passportFirstName + ' ' + student?.passportLastName
                              : '-'
                          }`,
                        })}
                      </Paragraph>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="longtail-booking-details__info-tooltip"
                      placement="topLeft"
                      trigger="hover"
                      overlay={this.renderTooltipContainer(
                        t('landlord.long_tail.booking_details.label.student_mobile', {
                          value:
                            student && student.phoneNumber && showStudentBasicInfo
                              ? this.hiddenPhoneByStatus(student.phoneNumber, payload.stage)
                              : '-',
                        }),
                      )}
                    >
                      <Paragraph ellipsis className="longtail-booking-details__info">
                        {t('landlord.long_tail.booking_details.label.student_mobile', {
                          value:
                            student && student.phoneNumber && showStudentBasicInfo
                              ? this.hiddenPhoneByStatus(student.phoneNumber, payload.stage)
                              : '-',
                        })}
                      </Paragraph>
                    </Tooltip>
                    <Tooltip
                      overlayClassName="longtail-booking-details__info-tooltip"
                      placement="topLeft"
                      trigger="hover"
                      overlay={this.renderTooltipContainer(
                        t('landlord.long_tail.booking_details.label.student_email', {
                          value:
                            student && student.emailAddress && showStudentBasicInfo
                              ? this.hiddenEmailByStatus(student.emailAddress, payload.stage)
                              : '-',
                        }),
                      )}
                    >
                      <Paragraph ellipsis className="longtail-booking-details__info">
                        {t('landlord.long_tail.booking_details.label.student_email', {
                          value:
                            student && student.emailAddress && showStudentBasicInfo
                              ? this.hiddenEmailByStatus(student.emailAddress, payload.stage)
                              : '-',
                        })}
                      </Paragraph>
                    </Tooltip>
                    <div>
                      {t('landlord.long_tail.booking_details.label.ref_number')}
                      <If condition={!!externalId}>
                        {externalId}
                        <span
                          className="longtail-booking-details__info-ref"
                          onClick={this.openReferenceModal}
                        >
                          <EditOutlined
                            style={{
                              color: '#38B2A6',
                            }}
                          />
                          Edit
                        </span>
                      </If>
                      <If condition={!externalId}>
                        <span
                          className="longtail-booking-details__info-ref"
                          onClick={this.openReferenceModal}
                        >
                          +{t('landlord.payment.long_tail.add.btn')}
                        </span>
                      </If>
                    </div>
                  </Col>
                  <If condition={!isShowCounterOffer}>
                    <Col
                      span={12}
                      className="longtail-booking-details__info-col"
                      style={{ width: 'auto', marginLeft: 0, paddingLeft: 0 }}
                    >
                      <Tooltip
                        overlayClassName="longtail-booking-details__info-tooltip"
                        placement="topLeft"
                        trigger="hover"
                        overlay={this.renderTooltipContainer(
                          t('landlord.long_tail.booking_details.label.room') +
                            (payload.unitTypeCategory
                              ? t(
                                  `landlord.long_tail.booking.unit_type_category.${payload.unitTypeCategory.toLowerCase()}`,
                                )
                              : '') +
                            (payload.unitTypeName ? `, ${payload.unitTypeName}` : '') +
                            (payload.propertyName ? `, ${payload.propertyName}` : ''),
                        )}
                      >
                        <Paragraph ellipsis className="longtail-booking-details__info">
                          {t('landlord.long_tail.booking_details.label.room')}
                          {payload.unitTypeCategory
                            ? t(
                                `landlord.long_tail.booking.unit_type_category.${payload.unitTypeCategory.toLowerCase()}`,
                              )
                            : ''}
                          {payload.unitTypeName ? `, ${payload.unitTypeName}` : ''}
                          {payload.propertyName ? `, ${payload.propertyName}` : ''}
                        </Paragraph>
                      </Tooltip>
                      <Tooltip
                        overlayClassName="longtail-booking-details__info-tooltip"
                        placement="topLeft"
                        trigger="hover"
                        overlay={this.renderTooltipContainer(
                          t('landlord.long_tail.booking_details.label.move_in_date', {
                            value:
                              payload && payload.moveInDate
                                ? moment(payload.moveInDate).format('DD/MM/YYYY')
                                : '-',
                          }),
                        )}
                      >
                        <Paragraph ellipsis className="longtail-booking-details__info">
                          {t('landlord.long_tail.booking_details.label.move_in_date', {
                            value:
                              payload && payload.moveInDate
                                ? moment(payload.moveInDate).format('DD/MM/YYYY')
                                : '-',
                          })}
                        </Paragraph>
                      </Tooltip>
                      <Tooltip
                        overlayClassName="longtail-booking-details__info-tooltip"
                        placement="topLeft"
                        trigger="hover"
                        overlay={this.renderTooltipContainer(
                          t('landlord.long_tail.booking_details.label.move_out_date', {
                            value:
                              payload && payload.moveOutDate
                                ? moment(payload.moveOutDate).format('DD/MM/YYYY')
                                : '-',
                          }),
                        )}
                      >
                        <Paragraph ellipsis className="longtail-booking-details__info">
                          {t('landlord.long_tail.booking_details.label.move_out_date', {
                            value:
                              payload && payload.moveOutDate
                                ? moment(payload.moveOutDate).format('DD/MM/YYYY')
                                : '-',
                          })}
                        </Paragraph>
                      </Tooltip>
                    </Col>
                  </If>
                  <If condition={isShowCounterOffer && counterOffersInfo}>
                    <Col
                      span={12}
                      className="longtail-booking-details__info-col"
                      style={{ width: 'auto', marginLeft: 0, paddingLeft: 0 }}
                    >
                      <Tooltip
                        overlayClassName="longtail-booking-details__info-tooltip"
                        placement="topLeft"
                        trigger="hover"
                        overlay={this.renderTooltipContainer(
                          t('landlord.long_tail.booking_details.label.room') +
                            (counterOffersInfo.unitTypeCategory
                              ? t(
                                  `landlord.long_tail.booking.unit_type_category.${counterOffersInfo.unitTypeCategory.toLowerCase()}`,
                                )
                              : '') +
                            (counterOffersInfo.unitTypeName
                              ? `, ${counterOffersInfo.unitTypeName}`
                              : '') +
                            (payload.propertyName ? `, ${payload.propertyName}` : ''),
                        )}
                      >
                        <Paragraph ellipsis className="longtail-booking-details__info">
                          {t('landlord.long_tail.booking_details.label.room')}
                          {counterOffersInfo.unitTypeCategory
                            ? t(
                                `landlord.long_tail.booking.unit_type_category.${counterOffersInfo.unitTypeCategory.toLowerCase()}`,
                              )
                            : ''}
                          {counterOffersInfo.unitTypeName
                            ? `, ${counterOffersInfo.unitTypeName}`
                            : ''}
                          {payload.propertyName ? `, ${payload.propertyName}` : ''}
                        </Paragraph>
                      </Tooltip>
                      <Tooltip
                        overlayClassName="longtail-booking-details__info-tooltip"
                        placement="topLeft"
                        trigger="hover"
                        overlay={this.renderTooltipContainer(
                          t('landlord.long_tail.booking_details.label.move_in_date', {
                            value:
                              counterOffersInfo && counterOffersInfo.moveInDate
                                ? moment(counterOffersInfo.moveInDate).format('DD/MM/YYYY')
                                : '-',
                          }),
                        )}
                      >
                        <Paragraph ellipsis className="longtail-booking-details__info">
                          {t('landlord.long_tail.booking_details.label.move_in_date', {
                            value:
                              counterOffersInfo && counterOffersInfo.moveInDate
                                ? moment(counterOffersInfo.moveInDate).format('DD/MM/YYYY')
                                : '-',
                          })}
                        </Paragraph>
                      </Tooltip>
                      <Tooltip
                        overlayClassName="longtail-booking-details__info-tooltip"
                        placement="topLeft"
                        trigger="hover"
                        overlay={this.renderTooltipContainer(
                          t('landlord.long_tail.booking_details.label.move_out_date', {
                            value:
                              counterOffersInfo && counterOffersInfo.moveOutDate
                                ? moment(counterOffersInfo.moveOutDate).format('DD/MM/YYYY')
                                : '-',
                          }),
                        )}
                      >
                        <Paragraph ellipsis className="longtail-booking-details__info">
                          {t('landlord.long_tail.booking_details.label.move_out_date', {
                            value:
                              counterOffersInfo && counterOffersInfo.moveOutDate
                                ? moment(counterOffersInfo.moveOutDate).format('DD/MM/YYYY')
                                : '-',
                          })}
                        </Paragraph>
                      </Tooltip>
                    </Col>
                  </If>
                </Row>
              </div>
            </Col>
            <Col span={8}>
              <div className="longtail-booking-details__btn-container">
                <If
                  condition={
                    landlordUser?.liveChatEnabled && order?.payload?.property && isShowMsgCenterIcon
                  }
                >
                  <MsgCenterBtn
                    t={t}
                    property={this.props.order.payload.property}
                    student={this.props.order.payload.student}
                    handleClickActionBtnTrack={this.handleClickActionBtnTrack}
                  />
                </If>
                <Choose>
                  <When
                    condition={payload.secondaryStage === orderSecondaryStage.PENDING_COUNTER_OFFER}
                  >
                    <CounterOfferEditModal
                      t={t}
                      id={payload?.id}
                      record={payload}
                      confirmOrder={this.confirmOrder}
                      isAutoOpen={this.typeFromLiveChat === 'edit'}
                      rejectOrder={this.counterOfferRejectEvent}
                      handleClickActionBtnTrack={this.handleClickActionBtnTrack}
                      history={this.props?.history}
                      from={pageType.bookingDetailPage}
                    />
                  </When>
                  <Otherwise>
                    <If condition={payload.stage === 'WAITING_FOR_CONFIRMATION'}>
                      <AcceptModal
                        t={t}
                        id={payload.id}
                        confirmOrder={this.confirmOrder}
                        record={payload}
                        isAutoOpen={this.typeFromLiveChat === 'accept'}
                        handleClickActionBtnTrack={this.handleClickActionBtnTrack}
                        history={this.props?.history}
                      />

                      <If condition={payload?.counterOffers?.length === 0}>
                        <div className="counter-offer-modal">
                          <Button onClick={this.openOrderCounterOfferModal}>
                            <FormOutlined />
                            {t('landlord.long_tail.booking.action.counter')}
                          </Button>
                        </div>
                      </If>

                      <RejectModal
                        t={t}
                        id={payload.id}
                        rejectOrder={this.rejectOrder}
                        isAutoOpen={this.typeFromLiveChat === 'reject'}
                        openOrderCounterOfferModal={this.openOrderCounterOfferModal}
                        handleClickActionBtnTrack={this.handleClickActionBtnTrack}
                        history={this.props?.history}
                      />
                    </If>
                  </Otherwise>
                </Choose>

                <CounterOfferModal
                  isAutoOpen={this.typeFromLiveChat === 'counterOffer'}
                  booking={this.props?.order?.payload}
                  from={pageType.bookingDetailPage}
                  wrappedComponentRef={this.counterOfferModalRef}
                  refetchBookingList={this.refetchBookingDetail}
                />
              </div>
              <div
                className={classNames('longtail-booking-details__booking-info', {
                  'longtail-booking-details__booking-instant-book-info': this.state.isInstantBook,
                })}
              >
                <div className="longtail-booking-details__price-info">
                  <label className="longtail-booking-details__label">
                    {t('landlord.long_tail.booking_details.label.total_price')}
                  </label>

                  <p className="longtail-booking-details__value">
                    {this.handleTotalHint()}
                    {formatPrice(
                      isShowCounterOffer && counterOffersInfo
                        ? counterOffersInfo.totalPrice
                        : payload.totalPrice,
                      payload.currency,
                    )}
                  </p>
                </div>
                <div className="longtail-booking-details__status-info">
                  <label className="longtail-booking-details__label">
                    {t('landlord.long_tail.booking_details.label.booking_status')}
                  </label>
                  <p className="longtail-booking-details__value">{handleBookingStatus()}</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div
          className="longtail-booking-details__header-nav"
          ref={node => {
            this.headerNav = node;
          }}
        >
          <ul className="longtail-booking-details__nav-list">
            <For of={Object.keys(this.headerNavList)} each="item" index="index">
              <If condition={this.isShowHeaderNav(this.headerNavList?.[item])}>
                <li
                  key={item}
                  className={classNames('longtail-booking-details__nav-item', {
                    'longtail-booking-details__nav-item--active': this.state.currentTab === index,
                  })}
                  onClick={() => {
                    this.handleNavClick(item, index);
                  }}
                  role="presentation"
                >
                  <span className="longtail-booking-details__nav-label">
                    {t(
                      this.state.isInstantBook && item === 'booking-process'
                        ? 'landlord.instant_book.booking_details.label.booking_process'
                        : `landlord.long_tail.booking_details.label.${item.replace(/-/g, '_')}`,
                    )}
                  </span>
                </li>
              </If>
            </For>
          </ul>
        </div>

        <ConfirmNoPaymentEle order={payload} refetch={this.getLongtailBookingDetail} />
        <If condition={payload.stage === orderStage.REFUNDING}>
          <p className="longtail-booking-details__refund-note">
            <ExclamationCircleFilled className="longtail-booking-details__refund-note-icon" />
            <span className="longtail-booking-details__refund-content">
              {t(
                this.state.isInstantBook
                  ? 'landlord.instant_book.booking_details.note.refund_to_student'
                  : 'landlord.long_tail.booking_details.note.refund_to_student',
              )}
            </span>
            <a href="#refund-info" className="longtail-booking-details__btn-details">
              {t('landlord.long_tail.booking_details.btn.details')}
            </a>
          </p>
        </If>
        <If condition={isShowCounterOffer}>
          <div className="longtail-booking-details__counter-offer-remind">
            <IconHint />
            <span className="longtail-booking-details__counter-offer-remind-desc">
              {t('landlord.booking.counter_offer.edit_modal.desc')}
            </span>
            <span
              className="longtail-booking-details__counter-offer-remind-check"
              onClick={this.checkCounterOffer}
            >
              {t('landlord.booking.counter_offer.check_detail_hint')}
            </span>
          </div>
        </If>
        <If condition={isRejectByStudent || isOverTime}>
          <div className="longtail-booking-details__reject-tip">
            <CloseCircleFilled className="longtail-booking-details__reject-tip-icon" />
            <p className="longtail-booking-details__reject-title">
              {isRejectByStudent && t('landlord.long_tail.booking_details.reject_title')}
              {isOverTime && t('landlord.booking.counter_offer.edit_modal.over_time.desc')}
            </p>
            {isRejectByStudent && (
              <p className="longtail-booking-details__reject-content">
                {t('landlord.long_tail.booking_details.reject_reason', {
                  reason: counterOffersInfo?.rejectReason,
                })}
              </p>
            )}
          </div>
        </If>
        <div
          className="longtail-booking-details__block"
          id="booking-process"
          ref={node => {
            this.bookingProcess = node;
          }}
        >
          <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
            {t(
              this.state.isInstantBook
                ? 'landlord.instant_book.booking_details.label.booking_process'
                : 'landlord.long_tail.booking_details.label.booking_process',
            )}
          </label>
          <div className="longtail-booking-details__process">
            <div className="longtail-booking-details__process-bar">
              <ProcessBar booking={payload} />
            </div>

            <Choose>
              <When condition={this.state.isInstantBook && isShownBookingProcessDetail}>
                <hr className="longtail-booking-details__divider longtail-booking-details__divider--processes" />
                <div className="longtail-booking-details__process-detail">
                  <If condition={processes && processes.length > 0}>
                    <InstantBookProcessesRecord
                      order={payload}
                      hasRejectedRefund={hasRejectedRefund}
                      showAllProcess={this.state.showAllProcess}
                      hasNonStripeRefundedRefund={hasNonStripeRefundedRefund}
                      hasStripeRefundedRefund={hasStripeRefundedRefund}
                      t={this.props.t}
                    />
                  </If>
                  <If condition={processes && processes.length > 2}>
                    <button
                      className="longtail-booking-details__view-more"
                      onClick={this.handleShowAll}
                    >
                      {!this.state.showAllProcess
                        ? t('landlord.longtail_booking.btn.view_more')
                        : t('landlord.longtail_booking.btn.view_less')}
                    </button>
                  </If>
                </div>
              </When>
              <When condition={!this.state.isInstantBook}>
                <hr className="longtail-booking-details__divider longtail-booking-details__divider--processes" />
                <div className="longtail-booking-details__process-detail">
                  <If condition={processes && processes.length > 0}>
                    {this.renderProcessRecord(
                      processes,
                      this.state.showAllProcess,
                      hasRejectedRefund,
                      hasStripeRefundedRefund,
                      hasNonStripeRefundedRefund,
                      isHercules,
                      isRerserveRoom,
                    )}
                  </If>
                </div>
              </When>
            </Choose>
          </div>
        </div>

        <If
          condition={
            !this.state.isInstantBook ||
            (payload.secondaryStage !== instantBookOrderSecondaryStage.NO_INVENTORY_AVAILABLE &&
              payload.stage !== instantBookOrderStage.FILLING_PERSONAL_INFO)
          }
        >
          <div
            className="longtail-booking-details__block"
            id="student-info"
            ref={node => {
              this.studentInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title">
              {t('landlord.long_tail.booking_details.label.student_info')}
            </label>
            <StudentInfo
              t={t}
              student={studentData}
              payload={payload}
              isHercules={isHercules}
              hiddenPhoneByStatus={this.hiddenPhoneByStatus}
              hiddenEmailByStatus={this.hiddenEmailByStatus}
            />
          </div>
        </If>

        <If condition={isShowDocumentInfo}>
          <div
            className="longtail-booking-details__block"
            id="document-info"
            ref={node => {
              this.documentInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.document_info')}
            </label>

            <DocumentInfo t={t} property={targetProperty} files={payload.uploadFiles ?? []} />
          </div>
        </If>

        <If condition={!this.state.isInstantBook && guarantor && Object.keys(guarantor).length > 0}>
          <div
            className="longtail-booking-details__block"
            id="guarantor-info"
            ref={node => {
              this.guarantorInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.guarantor_info')}
            </label>
            <GuarantorInfo
              t={t}
              guarantor={guarantor}
              payload={payload}
              hiddenPhoneByStatus={this.hiddenPhoneByStatus}
              hiddenEmailByStatus={this.hiddenEmailByStatus}
            />
          </div>
        </If>

        <div
          className="longtail-booking-details__block"
          id="product-info"
          ref={node => {
            this.productInfo = node;
          }}
        >
          <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
            {t('landlord.long_tail.booking_details.label.product_info')}
            <If condition={isNotComplete}>
              <span className="longtail-booking-details__block__product-not-accept-hint">
                <IconNotAccept />
                {t('landlord.booking.counter_offer.not_completed.hint')}
              </span>
            </If>
          </label>

          <If condition={!!payload?.counterOffers?.length}>
            <div className="longtail-booking-details__table-container-small longtail-booking-details__table-top">
              <label className="longtail-booking-details__table-title">
                {t('landlord.booking.counter_offer.detail.counter_offer')}
              </label>
              <If condition={isAcceptByStudent}>
                <span className="longtail-booking-details__product-accept-hint">
                  <IconAccept />
                  {t('landlord.booking.counter_offer.accept_by_student.hint')}
                </span>
              </If>
            </div>

            <Table
              className="longtail-booking-details__block-table"
              columns={this.productColumns}
              dataSource={this.getCounterOffer()}
              title={() => this.getProductInfoHeader('counterOffer')}
              pagination={false}
            />
          </If>

          <div className="longtail-booking-details__table-container-small longtail-booking-details__table-top">
            <If condition={!!payload?.counterOffers?.length}>
              <label className="longtail-booking-details__table-title">
                {t('landlord.booking.counter_offer.detail.origin')}
              </label>
            </If>

            <If condition={isAcceptOriginalByLandlord}>
              <span className="longtail-booking-details__product-accept-hint">
                <IconAccept />
                {t('landlord.booking.counter_offer.accept_by_landlord.hint')}
              </span>
            </If>
          </div>
          <Table
            className="longtail-booking-details__block-table"
            columns={this.productColumns}
            dataSource={this.getProductData()}
            title={() => this.getProductInfoHeader('order')}
            pagination={false}
          />
        </div>

        <If
          condition={
            !this.state.isInstantBook ||
            [
              instantBookOrderStage.BOOKING_CONFIRMED,
              instantBookOrderStage.CANCELLED,
              instantBookOrderStage.COMPLETED,
              instantBookOrderStage.CHECKED_IN,
              instantBookOrderStage.REFUNDING,
            ].includes(payload.stage)
          }
        >
          <div
            className="longtail-booking-details__block"
            id="payment-info"
            ref={node => {
              this.paymentInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.payment_info')}
            </label>

            <If
              condition={
                (payload.secondaryStage === 'PENDING_COUNTER_OFFER' &&
                  counterOffersInfo?.instalmentPlanType === null) ||
                (payload.secondaryStage !== 'PENDING_COUNTER_OFFER' &&
                  payload?.instalmentPlanType === null)
              }
            >
              <div className="longtail-booking-details__reselect-payment-notice">
                <IconTimerNotice />
                <span>{t('landlord.long_tail.booking_details.reselect_payment_plan.notice')}</span>
              </div>
            </If>

            <For of={!payload?.paymentOnline ? ['offline'] : ['online', 'offline']} each="status">
              <div className="longtail-booking-details__table-container" key={status}>
                <label className="longtail-booking-details__table-title">
                  {this.state.isInstantBook
                    ? t(`landlord.long_tail.booking_details.instant_book.title.${status}`)
                    : t(`landlord.long_tail.booking_details.title.${status}`)}
                </label>
                <If condition={this.state.isInstantBook}>
                  <p className="longtail-booking-details__table-summary">
                    {status === 'online'
                      ? t('landlord.long_tail.booking_details.instant_book.summary.online')
                      : !payload?.paymentOnline
                      ? t(
                          'landlord.long_tail.booking_details.instant_book.no_payment.summary.offline',
                        )
                      : t('landlord.long_tail.booking_details.instant_book.summary.offline')}
                  </p>
                </If>
                <If condition={!this.state.isInstantBook}>
                  <p className="longtail-booking-details__table-summary">
                    {status === 'online'
                      ? t('landlord.long_tail.booking_details.summary.online', {
                          dueHours: get(payload, 'paymentDuration'),
                        })
                      : !payload?.paymentOnline
                      ? t(
                          'landlord.long_tail.booking_details.instant_book.no_payment.summary.offline',
                        )
                      : t('landlord.long_tail.booking_details.instant_book.summary.offline')}
                  </p>
                </If>
                <Table
                  className="longtail-booking-details__block-table"
                  columns={this.paymentColumns}
                  dataSource={this.getPaymentData(status === 'online')}
                  pagination={false}
                />
              </div>
            </For>
            <If
              condition={
                !isNoPayment &&
                this.state.isInstantBook &&
                (this.state.showInstalmentPlanType || this.state.showGuarantorInfo)
              }
            >
              <div className="longtail-booking-details__payment-info--notice">
                <InfoCircleOutlined className="longtail-booking-details__payment-info--notice__icon" />
                <If condition={this.state.showInstalmentPlanType}>
                  <div
                    className={classNames(
                      'longtail-booking-details__payment-info--notice__instalment-plan',
                      {
                        'longtail-booking-details__payment-info--notice__instalment-plan--border':
                          this.state.showInstalmentPlanType && this.state.showGuarantorInfo,
                      },
                    )}
                  >
                    {t('landlord.long_tail.booking_details.instant_book.table.instalment-plan')}
                    {t(
                      `landlord.payment.long_tail.detail.instant_book.${payload.instalmentPlanType?.toLowerCase()}`,
                    )}
                  </div>
                </If>
                <If condition={this.state.showGuarantorInfo}>
                  <div className="longtail-booking-details__payment-info--notice__guarantor-info">
                    {t('landlord.long_tail.booking_details.instant_book.table.guarantor-info')}
                    <span
                      onClick={this.handleViewGuarantorInfoModal}
                      className="longtail-booking-details__payment-info--notice__guarantor-info__view"
                    >
                      {t('landlord.long_tail.booking.action.view')}
                    </span>
                  </div>
                </If>
              </div>
            </If>
          </div>
        </If>

        <If condition={this.getCommissionData() && this.getCommissionData().length > 0}>
          <div
            className="longtail-booking-details__block"
            id="commission-info"
            ref={node => {
              this.commissionInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.commission_info')}
            </label>
            <Table
              className="longtail-booking-details__block-table"
              columns={this.commissionColumns}
              dataSource={this.getCommissionData()}
              pagination={false}
            />
          </div>
        </If>

        <If condition={receivables && receivables.length > 0}>
          <div
            className="longtail-booking-details__block"
            id="payables-info"
            ref={node => {
              this.payablesInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.payables_info')}
            </label>
            <Table
              className="longtail-booking-details__block-table"
              columns={this.payablesColumns}
              dataSource={this.getPayablesData(receivables)}
              pagination={false}
              scroll={{ x: true }}
            />
          </div>
        </If>

        <If condition={payload?.paymentOnline && transfers && transfers.length > 0}>
          <div
            className="longtail-booking-details__block"
            id="transfer-info"
            ref={node => {
              this.transferInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.transfer_info')}
            </label>
            <Table
              className="longtail-booking-details__block-table"
              columns={this.transferColumns}
              dataSource={transfers}
              pagination={false}
            />
          </div>
        </If>

        <If condition={refunds && refunds.length > 0}>
          <div
            className="longtail-booking-details__block"
            id="refund-info"
            ref={node => {
              this.refundInfo = node;
            }}
          >
            <label className="longtail-booking-details__block-title longtail-booking-details__block-title--with-bottom">
              {t('landlord.long_tail.booking_details.label.refund_info')}
            </label>
            <Table
              className="longtail-booking-details__block-table"
              columns={this.refundColumns}
              dataSource={this.getRefundData(refunds)}
              pagination={false}
            />
          </div>
        </If>

        <TransferModal
          record={this.state.transferRecord}
          onCancel={this.handleViewTransferModal}
          t={this.props.t}
        />
        <ChargeModal
          record={this.state.chargeRecord}
          onCancel={this.handleViewChargeModal}
          t={this.props.t}
        />
        <RefundModal
          record={this.state.refundRecord}
          onCancel={this.handleViewRefundModal}
          showRefundComfirmBtn={this.state.showRefundComfirmBtn}
          t={this.props.t}
          confirmRefund={this.props.confirmRefund}
          getLongtailBookingDetail={this.getLongtailBookingDetail}
        />
        <RefundRejectModal
          t={this.props.t}
          visible={this.state.refundRejectVisible}
          record={this.state.refundRejectRecord}
          onCancel={this.handleViewRefundRejectModal}
          onSuccess={this.getLongtailBookingDetail}
        />
        <GuarantorInfoModal
          t={this.props.t}
          guarantor={guarantor}
          payload={payload}
          onCancel={this.handleViewGuarantorInfoModal}
          showGuarantorInfoModal={this.state.showGuarantorInfoModal}
          hiddenPhoneByStatus={this.hiddenPhoneByStatus}
          hiddenEmailByStatus={this.hiddenEmailByStatus}
        />
        <ReferenceModal
          id={id}
          externalId={externalId}
          visible={this.state.showReferenceModal}
          close={this.closeReferenceModal}
          getLongtailBookingDetail={this.getLongtailBookingDetail}
        />
      </div>
    );
  }
}

LongtailBookingsDetail.propTypes = {
  order: PropTypes.object.isRequired,
  landlordUser: PropTypes.object,
  t: PropTypes.func.isRequired,
  getLongtailBookingDetail: PropTypes.func,
  setLongtailBookingDetail: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
  confirmOrder: PropTypes.func,
  rejectOrder: PropTypes.func,
  confirmRefund: PropTypes.func,
};

LongtailBookingsDetail.defaultProps = {
  order: {},
  landlordUser: {},
  t: () => {},
  getLongtailBookingDetail: () => {},
  setLongtailBookingDetail: () => {},
  match: {
    match: {},
  },
  confirmOrder: () => {},
  rejectOrder: () => {},
  confirmRefund: () => {},
};
